var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 137,
    viewBox: "0 0 194 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 9.5,
    width: 53,
    height: 53,
    rx: 26.5,
    transform: "rotate(90 69 9.5)",
    fill: "#F2E9FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 28.5,
    width: 16,
    height: 16,
    rx: 8,
    transform: "rotate(90 168 28.5)",
    fill: "#EB3366"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_794_74230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.607 39.5703H56.0356C51.9724 39.5703 48.6785 42.8643 48.6785 46.9275V91.0703",
    stroke: "url(#paint0_linear_794_74230)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.321 46.9297V91.0725C144.321 95.1359 141.028 98.4297 136.964 98.4297H63.3928",
    stroke: "url(#paint1_linear_794_74230)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4998 81.875C103.61 81.875 109.375 76.1107 109.375 69C109.375 61.8893 103.61 56.125 96.4998 56.125C89.3891 56.125 83.6248 61.8893 83.6248 69C83.6248 76.1107 89.3891 81.875 96.4998 81.875Z",
    stroke: "url(#paint2_linear_794_74230)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4152 70.8387C64.3994 70.8387 63.5759 70.0152 63.5759 68.9994C63.5759 67.9836 64.3994 67.1602 65.4152 67.1602",
    stroke: "url(#paint3_linear_794_74230)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4155 70.8387C66.4313 70.8387 67.2548 70.0152 67.2548 68.9994C67.2548 67.9836 66.4313 67.1602 65.4155 67.1602",
    stroke: "url(#paint4_linear_794_74230)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.585 70.8387C126.569 70.8387 125.745 70.0152 125.745 68.9994C125.745 67.9836 126.569 67.1602 127.585 67.1602",
    stroke: "url(#paint5_linear_794_74230)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.585 70.8387C128.601 70.8387 129.424 70.0152 129.424 68.9994C129.424 67.9836 128.601 67.1602 127.585 67.1602",
    stroke: "url(#paint6_linear_794_74230)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.571 28.5352L129.607 39.5709L118.571 50.6066",
    stroke: "url(#paint7_linear_794_74230)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4285 87.3906L63.3928 98.4263L74.4285 109.462",
    stroke: "url(#paint8_linear_794_74230)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.5,
    cy: 116,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 104.5 116)",
    fill: "#00FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_794_74230",
    x1: 40.0006,
    y1: 95.9628,
    x2: 145.351,
    y2: 86.4832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_794_74230",
    x1: 54.7149,
    y1: 103.322,
    x2: 160.066,
    y2: 93.8426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_794_74230",
    x1: 80.8636,
    y1: 84.3213,
    x2: 114.545,
    y2: 82.3926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_794_74230",
    x1: 63.3787,
    y1: 71.1882,
    x2: 65.7904,
    y2: 71.1191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_794_74230",
    x1: 65.2183,
    y1: 71.1882,
    x2: 67.63,
    y2: 71.1191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_794_74230",
    x1: 125.548,
    y1: 71.1882,
    x2: 127.96,
    y2: 71.1191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_794_74230",
    x1: 127.387,
    y1: 71.1882,
    x2: 129.799,
    y2: 71.1191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_794_74230",
    x1: 117.388,
    y1: 52.7034,
    x2: 131.858,
    y2: 52.2891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_794_74230",
    x1: 62.2095,
    y1: 111.559,
    x2: 76.6799,
    y2: 111.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_794_74230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 103,
    fill: "white",
    transform: "translate(45 17.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.b9b3e61927f09cc10569cb35647e9505.svg";
export { ForwardRef as ReactComponent };